import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/api";

export interface Message {
  role: "user" | "assistant";
  content: string;
}

export interface GenerateImageResponse {
  success: boolean;
  imageUrl?: string;
}

/**
 * Send a chat message to the LLM with conversation history
 * @param messages - Array of messages representing the conversation
 * @returns Promise with the chat response
 */
export const sendChatMessage = async (messages: Message[]) => {
  try {
    const response = await axios.post(`${API_URL}/llm/chat`, { messages });
    return response.data;
  } catch (error) {
    console.error("Error sending chat message:", error);
    throw error;
  }
};

/**
 * Generate an image based on the prompt and question ID
 * @param prompt - The prompt to generate the image from
 * @param questionId - The ID of the question
 * @returns Promise with the image URL response
 */
export const generateImage = async (
  prompt: string,
  questionId: string
): Promise<GenerateImageResponse> => {
  try {
    const response = await axios.post(`${API_URL}/llm/imagegen`, {
      prompt,
      question_id: questionId,
    });
    return response.data;
  } catch (error) {
    console.error("Error generating image:", error);
    throw error;
  }
};
